module.exports = __webpack_public_path__ + "img/Desktop-2.d840bd47.jpg";